import React, { useState, useEffect,memo } from 'react';
import './slideanimation.scss';
const Slideshow = (props) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [index, setIndex] = useState(0);
    const [animationData, setAnimation] = useState('');
    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prevIndex) => (prevIndex === props.items.length - 1 ? 0 : prevIndex + 1));
            setCurrentIndex((prevIndex) => (prevIndex === props.items.length - 1 ? 0 : prevIndex + 1));
        }, props.items[index].duration * 1000);
        return () => clearInterval(interval);
    }, [index, props.items]);

    useEffect(() => {
        if(props.animation === 'fadein'){
            setAnimation('fadeIn 5s')
        }else if(props.animation === 'fadeout') {
            setAnimation('fadeIn 12s')
        }
    }, []);
    return (
        <div className="slideshow">
            {props.items.map((slide, index) => (
                <div>
                    {slide.type.includes('image') ?
                <img
                    src={slide.src}
                    key={index}
                    className={index === currentIndex ? `slide active` : `slide` }
                    style={{
                        backgroundImage: `url(${slide.src})`,
                        animationDelay: `${index * slide.duration}s`, // Delay animation for each slide
                        animation: `${animationData}`,
                    }}
                />
                    :
                        <video autoPlay muted loop
                               className={index === currentIndex ? 'slide active video-media-preview' : 'slide video-media-preview'}
                        >
                            <source src={slide.src} type="video/mp4"/>
                            Your browser does not support the video tag.
                        </video>

                    }
                </div>
            ))}
        </div>
    );
};

export default memo(Slideshow);
